import { all, fork, call, put, takeLatest } from 'redux-saga/effects'
import moment from 'moment'
import { constants } from '../../modules/jobFunctions/jobFollowUpActions'
import * as api from '../../api/job/followUps'

function* followUpsRefresh(action) {
  try {
    const payload = yield call(api.getJobFollowUps, action.jobId)
    yield put({ type: constants.FOLLOW_UPS_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.FOLLOW_UPS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchFollowUps() {
  yield takeLatest(constants.FOLLOW_UPS_REFRESH.ACTION, followUpsRefresh)
}

function* getRelatedEntity(action) {
  try {
    const entities = yield call(api.getRelatedEntity, action.followUpId)
    yield put({ type: constants.JOB_FOLLOW_UP_GET_RELATED_ENTITY.SUCCESS, entities })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_FOLLOW_UP_GET_RELATED_ENTITY.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetRelatedEntity() {
  yield takeLatest(constants.JOB_FOLLOW_UP_GET_RELATED_ENTITY.ACTION, getRelatedEntity)
}

function* sagaCreateFollowUp(action) {
  try {
    const payload = {
      job_id: action.jobId,
      type: action.content.type,
      due_date: moment(action.content.due_date).format('YYYY-MM-DD 10:00:00'),
      description: action.content.description,
      status: action.status,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      assigned_to_id:
        action.content.assigned_to_type === 'user' ? action.content.assigned_to_id : null,
      assigned_to_role_id:
        action.content.assigned_to_type === 'role' ? action.content.assigned_to_role_id : null
    }
    yield call(api.createJobFollowUp, payload)
    yield put({ type: constants.FOLLOW_UP_CREATE.SUCCESS, payload })
    yield call(followUpsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.FOLLOW_UP_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateFollowUp() {
  yield takeLatest(constants.FOLLOW_UP_CREATE.ACTION, sagaCreateFollowUp)
}

function* sagaUpdateFollowUp(action) {
  try {
    const payload = {
      follow_up_data: {
        type: action.content.type,
        due_date: moment(action.content.due_date).format('YYYY-MM-DD 10:00:00'),
        description: action.content.description,
        status: action.content.status,
        updated_by_id: action.userId,
        assigned_to_id:
          action.content.assigned_to_type === 'user' ? action.content.assigned_to_id : null,
        assigned_to_role_id:
          action.content.assigned_to_type === 'role' ? action.content.assigned_to_role_id : null
      },
      job_follow_up_id: action.followUpId,
      actor_name: action.content.actorName
    }

    yield call(api.updateJobFollowUp, payload)
    yield put({ type: constants.FOLLOW_UP_UPDATE.SUCCESS, payload })
    yield call(followUpsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.FOLLOW_UP_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateFollowUp() {
  yield takeLatest(constants.FOLLOW_UP_UPDATE.ACTION, sagaUpdateFollowUp)
}

function* sagaDeleteFollowUp(action) {
  try {
    const payload = {
      job_follow_up_id: action.followUpId
    }
    yield call(api.deleteJobFollowUp, payload)
    yield put({ type: constants.FOLLOW_UP_DELETE.SUCCESS, payload })
    yield call(followUpsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.FOLLOW_UP_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteFollowUp() {
  yield takeLatest(constants.FOLLOW_UP_DELETE.ACTION, sagaDeleteFollowUp)
}

function* getFollowUpActivities(action) {
  try {
    const payload = yield call(api.getJobFollowUpActivities, action.followUpId)
    yield put({ type: constants.GET_FOLLOW_UP_ACTIVITIES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_FOLLOW_UP_ACTIVITIES.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetFollowUpActivities() {
  yield takeLatest(constants.GET_FOLLOW_UP_ACTIVITIES.ACTION, getFollowUpActivities)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchFollowUps),
    fork(watchCreateFollowUp),
    fork(watchUpdateFollowUp),
    fork(watchDeleteFollowUp),

    fork(watchGetFollowUpActivities),

    fork(watchGetRelatedEntity)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobFollowUpSaga.js